import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

export const generateImpressionForLocalisedPricing = () => EnterpriseExperiments.get('enableWESLocalisedPricing');
